import { CALL_API } from "redux-api-middleware";
import { ho } from "apis/homeowner/ho";
import {
  REQUEST_GENERATE_PDF,
  RECEIVE_GENERATE_PDF,
  ERROR_GENERATE_PDF,
  REQUEST_REGENERATE_PDF,
  RECEIVE_REGENERATE_PDF,
  ERROR_REGENERATE_PDF
} from "typeConstants";

const generatePDF = (id) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.generatePdf(id),
        method: "GET",
        types: [
          REQUEST_GENERATE_PDF,
          {
            type: RECEIVE_GENERATE_PDF,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_GENERATE_PDF,
          }
        ]
      }
    });
};


const regeneratePDF = (id) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.regeneratePdf(id),
        method: "GET",
        types: [
          REQUEST_REGENERATE_PDF,
          {
            type: RECEIVE_REGENERATE_PDF,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_REGENERATE_PDF,
          }
        ]
      }
    });
};


export {
  generatePDF,
  regeneratePDF
};
